import { withDeliveryCopyOperation } from './deliveryCopyOperation';
import { hasLegacyDelivery } from './deliveryOutbox';

export { withLegacyDeliveryOperation } from './deliveryOutbox';

// Receipt reads and local retention do not call this send-admission boundary.
// Prepared writes still need their own exact principal/attempt/current-authority
// checks; the legacy row is only a generic hold, never an acceptance claim.
export async function withPreparedDeliveryOperation(orderId, action, { context, isCurrent = () => true } = {}) {
  return withDeliveryCopyOperation(orderId, async (ownedContext) => {
    if (!isCurrent()) throw new Error('The delivery opening changed. Nothing was sent or changed.');
    const legacy = await hasLegacyDelivery(orderId);
    if (typeof legacy !== 'boolean') throw new Error('Saved work could not be checked. Nothing was sent or changed.');
    if (legacy) throw new Error('An older saved copy exists for this order. Both copies are retained; nothing was sent or changed.');
    return withDeliveryCopyOperation(orderId, () => {
      if (!isCurrent()) throw new Error('The delivery opening changed. Nothing was sent or changed.');
      return action(ownedContext);
    }, { context: ownedContext, requireCrossContext: true });
  }, { context, requireCrossContext: true });
}
